var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "result-search-page" } }, [
    _c("div", { class: _vm.containerClasses }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "search-result-top" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "bottom space-between" }, [
              _c("div", { staticClass: "left" }, [
                _vm.total > 0
                  ? _c("span", { staticClass: "showing select-all" }, [
                      _c("strong", [_vm._v("Showing")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.from))]),
                      _vm._v("-"),
                      _c("span", [_vm._v(_vm._s(_vm.to))]),
                      _vm._v(" of "),
                      _c("span", [_vm._v(_vm._s(_vm.total))]),
                      _vm._v(
                        "\n                            results\n                        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "view-type-selection select-all" }, [
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "grid" ? "active" : "",
                      attrs: { for: "view-grid" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-grid",
                          type: "radio",
                          value: "grid"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "grid") },
                        on: {
                          change: [
                            function($event) {
                              _vm.viewType = "grid"
                            },
                            _vm.onViewChange
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-th" } })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      class: _vm.viewType === "list" ? "active" : "",
                      attrs: { for: "view-list" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.viewType,
                            expression: "viewType"
                          }
                        ],
                        attrs: {
                          id: "view-list",
                          type: "radio",
                          value: "list"
                        },
                        domProps: { checked: _vm._q(_vm.viewType, "list") },
                        on: {
                          change: [
                            function($event) {
                              _vm.viewType = "list"
                            },
                            _vm.onViewChange
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("icon", { attrs: { icon: " fa-lg fa-list" } })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.viewType === "grid"
                  ? _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.perRow,
                            expression: "perRow"
                          }
                        ],
                        staticClass: "per-row",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.perRow = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(_vm.vehicles_in_row_options, function(option) {
                        return _c(
                          "option",
                          { domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(option.text) +
                                "\n                            "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right" })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom filters" },
              [
                _c(
                  "RecentDatesSelector",
                  {
                    attrs: {
                      showAll: false,
                      id: "role",
                      custom: { custom: "Custom", all_past: "All Past" }
                    },
                    on: {
                      change: function($event) {
                        return _vm.getData()
                      }
                    },
                    model: {
                      value: _vm.date_option,
                      callback: function($$v) {
                        _vm.date_option = $$v
                      },
                      expression: "date_option"
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Filter By Date")
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.date_option === "custom"
                  ? _c(
                      "div",
                      [
                        _c("label", { attrs: { for: "custom_date" } }, [
                          _vm._v(" ")
                        ]),
                        _vm._v(" "),
                        _c("b-form-input", {
                          attrs: { type: "date", id: "custom_date" },
                          model: {
                            value: _vm.custom_date,
                            callback: function($$v) {
                              _vm.custom_date = $$v
                            },
                            expression: "custom_date"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "container-table col-md-12" }, [
            _vm.total === 0
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      "\n                        Vehicles not found.\n                    "
                    )
                  ])
                ])
              : _c("div", [
                  _vm.viewType === "list"
                    ? _c("div", { attrs: { id: "bid-history" } }, [
                        _vm.vehicleViews
                          ? _c(
                              "div",
                              { staticClass: "all-bid table-responsive" },
                              [
                                _c(
                                  "table",
                                  { staticClass: "bid-history table" },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [_vm._v("(+/-)")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Day")]),
                                        _vm._v(" "),
                                        _c("th", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "#!",
                                                title:
                                                  "Click to sort by auction"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleSorting(
                                                    "auc_asc",
                                                    "auc_desc"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Auc\n                                        "
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            "/\n                                        "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "#!",
                                                title: "Click to sort by lot"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleSorting(
                                                    "lot_asc",
                                                    "lot_desc"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Lot\n                                        "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("ID")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Make")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Model/Grade")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Chassis")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Year")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Kms")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Colour")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("CC")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Trans")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("F")]),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Cnd")]),
                                        _vm._v(" "),
                                        _c("th"),
                                        _vm._v(" "),
                                        _c("th", [_vm._v("Start")]),
                                        _vm._v(" "),
                                        _c(
                                          "th",
                                          {
                                            attrs: {
                                              title:
                                                "Click to sort by auction date "
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.sortOrderBy = "auction_date"
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        Result\n                                    "
                                            )
                                          ]
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(_vm.vehicleViews, function(
                                          data,
                                          index
                                        ) {
                                          return [
                                            !data.vehicle
                                              ? _c(
                                                  "tr",
                                                  {
                                                    key:
                                                      "nodata-" +
                                                      data.vehicle_id,
                                                    staticClass: "hr"
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        attrs: { colspan: "17" }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "No data for vehicle " +
                                                            _vm._s(
                                                              data.vehicle_id
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "tr",
                                                  {
                                                    key: data.vehicle.api_id,
                                                    staticClass: "hr",
                                                    on: {
                                                      contextmenu: function(
                                                        $event
                                                      ) {
                                                        $event.preventDefault()
                                                        return _vm.tagPopupModal(
                                                          data.vehicle.api_id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "tag" },
                                                      [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .vehicleFavourites[
                                                                  data.vehicle
                                                                    .api_id
                                                                ],
                                                              expression:
                                                                "vehicleFavourites[data.vehicle.api_id]"
                                                            }
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                            id:
                                                              "tag-" +
                                                              data.vehicle
                                                                .api_id
                                                          },
                                                          domProps: {
                                                            value: true,
                                                            checked: Array.isArray(
                                                              _vm
                                                                .vehicleFavourites[
                                                                data.vehicle
                                                                  .api_id
                                                              ]
                                                            )
                                                              ? _vm._i(
                                                                  _vm
                                                                    .vehicleFavourites[
                                                                    data.vehicle
                                                                      .api_id
                                                                  ],
                                                                  true
                                                                ) > -1
                                                              : _vm
                                                                  .vehicleFavourites[
                                                                  data.vehicle
                                                                    .api_id
                                                                ]
                                                          },
                                                          on: {
                                                            change: [
                                                              function($event) {
                                                                var $$a =
                                                                    _vm
                                                                      .vehicleFavourites[
                                                                      data
                                                                        .vehicle
                                                                        .api_id
                                                                    ],
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c = $$el.checked
                                                                    ? true
                                                                    : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v = true,
                                                                    $$i = _vm._i(
                                                                      $$a,
                                                                      $$v
                                                                    )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        _vm.vehicleFavourites,
                                                                        data
                                                                          .vehicle
                                                                          .api_id,
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        _vm.vehicleFavourites,
                                                                        data
                                                                          .vehicle
                                                                          .api_id,
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    _vm.vehicleFavourites,
                                                                    data.vehicle
                                                                      .api_id,
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                              function($event) {
                                                                return _vm.onFavChange(
                                                                  data.vehicle
                                                                    .api_id
                                                                )
                                                              }
                                                            ]
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("label", {
                                                          attrs: {
                                                            for:
                                                              "tag-" +
                                                              data.vehicle
                                                                .api_id
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("small", [
                                                          _vm._v("Tag")
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.getDate(
                                                                data.vehicle
                                                                  .auction_date
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "yellow" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                data.vehicle
                                                                  .detail_url
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.goToCar(
                                                                  data.vehicle
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.vehicle
                                                                    .auction_house
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  data.vehicle
                                                                    .lot
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "id-bid" },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href:
                                                                data.vehicle
                                                                  .detail_url
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.goToCar(
                                                                  data.vehicle
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  data.vehicle
                                                                    .api_id
                                                                ) +
                                                                "\n                                            "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "image-hover-container"
                                                          },
                                                          [
                                                            _c(
                                                              "vehicle-hover-images",
                                                              {
                                                                attrs: {
                                                                  vehicle:
                                                                    data.vehicle,
                                                                  letters_only: true
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "make" },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              data.vehicle.make
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "model" },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              data.vehicle.model
                                                            ) +
                                                            " / " +
                                                            _vm._s(
                                                              data.vehicle.grade
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle.chassis
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle.year
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle.mileage
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "color" },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              data.vehicle.color
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle
                                                              .engine_capacity
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle
                                                              .transmission
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle
                                                              .fuel_type
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle
                                                              .condition
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            data.vehicle
                                                              .equipment
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "td",
                                                      { staticClass: "blue" },
                                                      [
                                                        _vm._v(
                                                          "\n                                            ¥ " +
                                                            _vm._s(
                                                              data.vehicle
                                                                .start_price
                                                            ) +
                                                            "\n                                        "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !_vm.is_mobile
                                                      ? _c(
                                                          "td",
                                                          {
                                                            class: _vm.isSold(
                                                              data.vehicle
                                                                .auction_date
                                                            )
                                                              ? "sold"
                                                              : ""
                                                          },
                                                          [
                                                            _c(
                                                              "small",
                                                              {
                                                                attrs: {
                                                                  title: _vm.getJapanDiff(
                                                                    data.vehicle
                                                                      .auction_date
                                                                  )
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      _vm.getTime(
                                                                        data
                                                                          .vehicle
                                                                          .auction_date,
                                                                        "h:mma"
                                                                      )
                                                                    ) +
                                                                    " JPN /\n                                                " +
                                                                    _vm._s(
                                                                      _vm
                                                                        .getNZDateTime(
                                                                          data
                                                                            .vehicle
                                                                            .auction_date
                                                                        )
                                                                        .format(
                                                                          "h:mma"
                                                                        )
                                                                    ) +
                                                                    " NZ\n                                            "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            data.vehicle
                                                              .hw_auc_cost > 0
                                                              ? _c("div", [
                                                                  data.vehicle
                                                                    .hw_auc_status
                                                                    ? _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              data
                                                                                .vehicle
                                                                                .hw_auc_status
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c("br"),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "blue",
                                                                      attrs: {
                                                                        title:
                                                                          _vm.numberWithCommas(
                                                                            data
                                                                              .vehicle
                                                                              .hw_auc_cost
                                                                          ) +
                                                                          "k yen"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                ¥ " +
                                                                          _vm._s(
                                                                            _vm.numberWithCommas(
                                                                              data
                                                                                .vehicle
                                                                                .hw_auc_cost
                                                                            )
                                                                          ) +
                                                                          " k\n                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                ])
                                                              : _vm.isSold(
                                                                  data.vehicle
                                                                    .auction_date
                                                                )
                                                              ? _c(
                                                                  "div",
                                                                  [
                                                                    data.vehicle
                                                                      .bid_status ===
                                                                    "negotiation"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Negotiation"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : data
                                                                          .vehicle
                                                                          .bid_status ===
                                                                        "cancelled"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Cancelled"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : data
                                                                          .vehicle
                                                                          .bid_status ===
                                                                        "sold"
                                                                      ? _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Sold"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Not sold"
                                                                            )
                                                                          ]
                                                                        ),
                                                                    _vm._v(" "),
                                                                    data.vehicle
                                                                      .end_price &&
                                                                    data.vehicle
                                                                      .end_price >
                                                                      0
                                                                      ? [
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "blue",
                                                                              attrs: {
                                                                                title:
                                                                                  _vm.numberWithCommas(
                                                                                    data
                                                                                      .vehicle
                                                                                      .end_price
                                                                                  ) +
                                                                                  " yen"
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                    ¥ " +
                                                                                  _vm._s(
                                                                                    _vm.numberWithCommas(
                                                                                      data
                                                                                        .vehicle
                                                                                        .end_price /
                                                                                        1000
                                                                                    )
                                                                                  ) +
                                                                                  " k\n                                                "
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      : _vm._e()
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _vm.is_mobile
                                              ? _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      class: _vm.isSold(
                                                        data.vehicle
                                                          .auction_date
                                                      )
                                                        ? "sold"
                                                        : "",
                                                      attrs: { colspan: "14" }
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          attrs: {
                                                            title: _vm.getJapanDiff(
                                                              data.vehicle
                                                                .auction_date
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                " +
                                                              _vm._s(
                                                                _vm.getTime(
                                                                  data.vehicle
                                                                    .auction_date,
                                                                  "h:mma"
                                                                )
                                                              ) +
                                                              " JPN /\n                                                " +
                                                              _vm._s(
                                                                _vm
                                                                  .getNZDateTime(
                                                                    data.vehicle
                                                                      .auction_date
                                                                  )
                                                                  .format(
                                                                    "h:mma"
                                                                  )
                                                              ) +
                                                              " NZ\n                                            "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      data.vehicle.hw_auc_cost >
                                                      0
                                                        ? _c("div", [
                                                            data.vehicle
                                                              .hw_auc_status
                                                              ? _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      data
                                                                        .vehicle
                                                                        .hw_auc_status
                                                                    )
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "blue",
                                                                attrs: {
                                                                  title:
                                                                    _vm.numberWithCommas(
                                                                      data
                                                                        .vehicle
                                                                        .hw_auc_cost
                                                                    ) + "k yen"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                ¥ " +
                                                                    _vm._s(
                                                                      _vm.numberWithCommas(
                                                                        data
                                                                          .vehicle
                                                                          .hw_auc_cost
                                                                      )
                                                                    ) +
                                                                    " k\n                                            "
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        : _vm.isSold(
                                                            data.vehicle
                                                              .auction_date
                                                          )
                                                        ? _c(
                                                            "div",
                                                            [
                                                              data.vehicle
                                                                .bid_status ===
                                                              "negotiation"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "Negotiation"
                                                                    )
                                                                  ])
                                                                : data.vehicle
                                                                    .bid_status ===
                                                                  "cancelled"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "Cancelled"
                                                                    )
                                                                  ])
                                                                : data.vehicle
                                                                    .bid_status ===
                                                                  "sold"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "Sold"
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      "Not sold"
                                                                    )
                                                                  ]),
                                                              _vm._v(" "),
                                                              data.vehicle
                                                                .end_price &&
                                                              data.vehicle
                                                                .end_price > 0
                                                                ? [
                                                                    _c("br"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "blue",
                                                                        attrs: {
                                                                          title:
                                                                            _vm.numberWithCommas(
                                                                              data
                                                                                .vehicle
                                                                                .end_price
                                                                            ) +
                                                                            " yen"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                    ¥ " +
                                                                            _vm._s(
                                                                              _vm.numberWithCommas(
                                                                                data
                                                                                  .vehicle
                                                                                  .end_price /
                                                                                  1000
                                                                              )
                                                                            ) +
                                                                            " k\n                                                "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.vehicle
                                              ? _vm._l(
                                                  data.vehicle.bids,
                                                  function(bid) {
                                                    return _c("tr", [
                                                      _c(
                                                        "td",
                                                        {
                                                          attrs: {
                                                            colspan: "17"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "bid"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "date item"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.getDate(
                                                                          bid.created_at
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "hour item"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.getTime(
                                                                          bid.created_at
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "note item"
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        bid.note
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(
                                                                    "\n                                                        [SystemNote: " +
                                                                      _vm._s(
                                                                        bid.bid_by_name
                                                                      ) +
                                                                      ";\n                                                        landed=" +
                                                                      _vm._s(
                                                                        bid.currency_sign
                                                                      ) +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          bid.bid_price_landed
                                                                        )
                                                                      ) +
                                                                      "; FX=" +
                                                                      _vm._s(
                                                                        bid.exchange_rate
                                                                      ) +
                                                                      "]\n                                                    "
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item bid-details-container",
                                                                  style: _vm.bidColourStyle(
                                                                    bid
                                                                  )
                                                                },
                                                                [
                                                                  bid.user
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "who"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a",
                                                                            {
                                                                              staticClass:
                                                                                "person",
                                                                              attrs: {
                                                                                href:
                                                                                  "#!"
                                                                              },
                                                                              on: {
                                                                                click: function(
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.filterBidUser(
                                                                                    bid
                                                                                      .user
                                                                                      .id
                                                                                  )
                                                                                }
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  bid
                                                                                    .user
                                                                                    .name
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          bid
                                                                            .user
                                                                            .company
                                                                            ? _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      bid
                                                                                        .user
                                                                                        .company
                                                                                        .name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e(),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "bump"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.bumpBidDisplay(
                                                                                    bid.bump_bid
                                                                                  )
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "bid-placed"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          class: bid.bump_bid
                                                                            ? "strikeout"
                                                                            : ""
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                                                ¥ " +
                                                                              _vm._s(
                                                                                _vm.numberWithCommas(
                                                                                  bid.bid_price_jpy
                                                                                )
                                                                              ) +
                                                                              "\n                                                            "
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      bid.bump_bid
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "bid-total"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                                                                Cost ¥ " +
                                                                                  _vm._s(
                                                                                    _vm.numberWithCommas(
                                                                                      bid.bid_price_jpy +
                                                                                        bid.bump_bid
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                                            "
                                                                              )
                                                                            ]
                                                                          )
                                                                        : _vm._e()
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "tag"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "input",
                                                                        {
                                                                          directives: [
                                                                            {
                                                                              name:
                                                                                "model",
                                                                              rawName:
                                                                                "v-model",
                                                                              value:
                                                                                _vm
                                                                                  .bidFavourites[
                                                                                  bid
                                                                                    .id
                                                                                ],
                                                                              expression:
                                                                                "bidFavourites[bid.id]"
                                                                            }
                                                                          ],
                                                                          attrs: {
                                                                            type:
                                                                              "checkbox",
                                                                            id:
                                                                              "bidtag-" +
                                                                              bid.id
                                                                          },
                                                                          domProps: {
                                                                            value: true,
                                                                            checked: Array.isArray(
                                                                              _vm
                                                                                .bidFavourites[
                                                                                bid
                                                                                  .id
                                                                              ]
                                                                            )
                                                                              ? _vm._i(
                                                                                  _vm
                                                                                    .bidFavourites[
                                                                                    bid
                                                                                      .id
                                                                                  ],
                                                                                  true
                                                                                ) >
                                                                                -1
                                                                              : _vm
                                                                                  .bidFavourites[
                                                                                  bid
                                                                                    .id
                                                                                ]
                                                                          },
                                                                          on: {
                                                                            change: [
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                var $$a =
                                                                                    _vm
                                                                                      .bidFavourites[
                                                                                      bid
                                                                                        .id
                                                                                    ],
                                                                                  $$el =
                                                                                    $event.target,
                                                                                  $$c = $$el.checked
                                                                                    ? true
                                                                                    : false
                                                                                if (
                                                                                  Array.isArray(
                                                                                    $$a
                                                                                  )
                                                                                ) {
                                                                                  var $$v = true,
                                                                                    $$i = _vm._i(
                                                                                      $$a,
                                                                                      $$v
                                                                                    )
                                                                                  if (
                                                                                    $$el.checked
                                                                                  ) {
                                                                                    $$i <
                                                                                      0 &&
                                                                                      _vm.$set(
                                                                                        _vm.bidFavourites,
                                                                                        bid.id,
                                                                                        $$a.concat(
                                                                                          [
                                                                                            $$v
                                                                                          ]
                                                                                        )
                                                                                      )
                                                                                  } else {
                                                                                    $$i >
                                                                                      -1 &&
                                                                                      _vm.$set(
                                                                                        _vm.bidFavourites,
                                                                                        bid.id,
                                                                                        $$a
                                                                                          .slice(
                                                                                            0,
                                                                                            $$i
                                                                                          )
                                                                                          .concat(
                                                                                            $$a.slice(
                                                                                              $$i +
                                                                                                1
                                                                                            )
                                                                                          )
                                                                                      )
                                                                                  }
                                                                                } else {
                                                                                  _vm.$set(
                                                                                    _vm.bidFavourites,
                                                                                    bid.id,
                                                                                    $$c
                                                                                  )
                                                                                }
                                                                              },
                                                                              function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.onBidFavChange(
                                                                                  bid.id
                                                                                )
                                                                              }
                                                                            ]
                                                                          }
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "label",
                                                                        {
                                                                          attrs: {
                                                                            for:
                                                                              "bidtag-" +
                                                                              bid.id
                                                                          }
                                                                        }
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          bid.messages
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "collapse show",
                                                                  attrs: {
                                                                    id:
                                                                      "bid-messages-" +
                                                                      bid.id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._l(
                                                                    bid.messages,
                                                                    function(
                                                                      msg
                                                                    ) {
                                                                      return [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "bid history-bid",
                                                                            class: _vm.messageClass(
                                                                              msg,
                                                                              bid
                                                                            ),
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.selectMessage(
                                                                                  msg
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "date item"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      _vm.getDate(
                                                                                        msg.created_at
                                                                                      )
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "hour item"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      _vm.getTime(
                                                                                        msg.created_at
                                                                                      )
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "message-by item"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                                                " +
                                                                                    _vm._s(
                                                                                      msg.firstname
                                                                                    ) +
                                                                                    " " +
                                                                                    _vm._s(
                                                                                      msg.lastname
                                                                                    ) +
                                                                                    "\n                                                            "
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "note item"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  [
                                                                                    msg.rep_only
                                                                                      ? _c(
                                                                                          "strong",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "staff: "
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      "\n                                                                    " +
                                                                                        _vm._s(
                                                                                          msg.message
                                                                                        ) +
                                                                                        "\n                                                                "
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  )
                                                                ],
                                                                2
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "history-buttons"
                                                            },
                                                            [
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "link add-message",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.openMessageModal(
                                                                        bid
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm.$userIsAdmin()
                                                                    ? [
                                                                        _vm._v(
                                                                          " Client Message "
                                                                        )
                                                                      ]
                                                                    : [
                                                                        _vm._v(
                                                                          "Add Message"
                                                                        )
                                                                      ]
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.$userIsAdmin()
                                                                ? [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "link copy-stock",
                                                                        class:
                                                                          _vm.copiedToStock.indexOf(
                                                                            data.api_id
                                                                          ) !==
                                                                          -1
                                                                            ? "disabled"
                                                                            : "",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.copyVehicleToStock(
                                                                              data.api_id
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                                                            Copy to dealer stock\n                                                        "
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "link staff-message",
                                                                  attrs: {
                                                                    disabled: !_vm.$canChangeBid(
                                                                      data.auction_date
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.openChangeBidModal(
                                                                        bid
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Change bid"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              bid.sbl_id &&
                                                              _vm.$userIsAdmin()
                                                                ? [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "link staff-message",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.addBidMessage(
                                                                              bid.id,
                                                                              _vm.keepBidMsg,
                                                                              true
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Keep Bid"
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    bid.bid_price_jpy
                                                                      ? _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "link staff-message",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.cancelBid(
                                                                                  bid.id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Cancel bid"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        staticClass:
                                                                          "link staff-message",
                                                                        on: {
                                                                          click: function(
                                                                            $event
                                                                          ) {
                                                                            return _vm.openChangeBidModal(
                                                                              bid
                                                                            )
                                                                          }
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Change bid"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                : _vm._e()
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  }
                                                )
                                              : _vm._e()
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "container-results",
                          attrs: { id: "container-results" }
                        },
                        [
                          _vm.vehicleViews && _vm.vehicleViews.length
                            ? _vm._l(_vm.vehicleViews, function(view) {
                                return _c("Vehicle", {
                                  key: view.id,
                                  attrs: {
                                    vehicle: view.vehicle,
                                    priceField: "start_price"
                                  },
                                  on: { tagPopupModal: _vm.tagPopupModal }
                                })
                              })
                            : [
                                _vm.loading
                                  ? [
                                      _vm._v(
                                        "\n                                Loading...\n                            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                                No Bids found.\n                            "
                                      )
                                    ]
                              ],
                          _vm._v(" "),
                          _vm._l([1, 2, 3, 4, 5, 6, 7, 8], function(vehicle) {
                            return _c("div", {
                              staticClass: "single-result-search none"
                            })
                          })
                        ],
                        2
                      )
                ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-12 d-flex justify-content-end" },
            [
              _vm.total > 0
                ? _c("b-pagination", {
                    attrs: {
                      "total-rows": _vm.total,
                      "per-page": _vm.per_page
                    },
                    model: {
                      value: _vm.current_page,
                      callback: function($$v) {
                        _vm.current_page = $$v
                      },
                      expression: "current_page"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.$userCan("fav_list")
            ? _c("favourite-tag-modal", {
                attrs: { vehicleId: _vm.vehicle_id },
                on: { changed: _vm.onTagChanged },
                model: {
                  value: _vm.favListModalOpen,
                  callback: function($$v) {
                    _vm.favListModalOpen = $$v
                  },
                  expression: "favListModalOpen"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("change-bid", {
            ref: "changeBidModal",
            on: { changed: _vm.onBidChange }
          }),
          _vm._v(" "),
          _c("bid-message", {
            ref: "bidMessage",
            on: { changed: _vm.onBidChange }
          }),
          _vm._v(" "),
          _c("staff-message", {
            ref: "staffMessage",
            on: { changed: _vm.onBidChange }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "left" }, [
        _c("h2", [_vm._v("Viewed Vehicles")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "right" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d3c2388", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d3c2388","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleViewsPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d3c2388","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleViewsPage.vue
// module chunks = 0